export default "__VITE_ASSET__NRtfGMTI__"